<script>
import axios from '@/utils/axios';
import "vue3-carousel/dist/carousel.css";
import { useToast } from 'vue-toastification';
import { projectUtils } from '@/utils/project';
import { Carousel, Slide } from "vue3-carousel";
import ProjectDetailsCarousel from "@/assets/json/project-details-carousel.json";

export default {
 inject: ['setLoading'], 
  components: {
   Carousel,
   Slide,
  },

  data() {
    return {
     errors: {},
     app_currency: '',
     toast: useToast(),
     project: [], 
     pipelines: [],
     project_id: '',
     team_members: [],
     pipeline_histories: [],
     ProjectDetailsCarousel: ProjectDetailsCarousel,
     settings: {
      itemsToShow: 1,
      snapAlign: "center",
      loop: true,
     },
     breakpoints: {
      575: {
       itemsToShow: 2,
       snapAlign: "center",
      },
      767: {
       itemsToShow: 2,
       snapAlign: "center",
      },
      991: {
       itemsToShow: 3,
       snapAlign: "center",
      },
      1024: {
       itemsToShow: 3,
       snapAlign: "start",
      },
     },
     projectUtils
    };
  },
  
  async mounted(){
   const project_id = this.$route.params.id;
   this.project_id = project_id;
   this.main();
  },

  methods: {

   async main(){
    this.projectById(this.project_id); 
    this.pipelines = await projectUtils.projectPipelines();
    this.app_currency = await this.$appCurrency();
    this.teamMembers();
    this.pipelineHistory();
   }, 
   
   async projectById(project_id){
    this.setLoading(true);
    try{
     const response = await axios.get(`/projects/${project_id}`);
     this.project = response.data.data; 
    }catch(error){
     this.toast.error(error.message);
    }finally{
     this.setLoading(false); 
    }
   },

   async teamMembers(){
    try{
     const response = await axios.get(`/projects/${this.project_id}/team`);
     this.team_members = response.data.data; 
    }catch(error){
     this.toast.error(error.message);
    }
   },

   async pipelineHistory(){
    this.setLoading(true);
    try{
     const response = await axios.get(`/projects/${this.project_id}/pipeline`);
     this.pipeline_histories = response.data.data; 
    }catch(error){
     this.toast.error(error.message); 
    }finally{
     this.setLoading(false); 
    }
   },

   async downloadDocument(doc) {
    try{
     this.setLoading(true);   
     const response = await axios({
      url: `/projects/documents/${doc.id}/download`,
      method: 'GET',
      responseType: 'blob'
     });
        
     // Get the content-type from response headers
     const contentType = response.headers['content-type'];
        
     // Create blob with the correct MIME type
     const blob = new Blob([response.data], { type: contentType });
     const fileURL = window.URL.createObjectURL(blob);
        
     // Create temporary link and trigger download
     const link = document.createElement('a');
     link.href = fileURL;
     link.download = doc.name || 'download';
     document.body.appendChild(link);
     link.click();
        
     // Cleanup
     document.body.removeChild(link);
     window.URL.revokeObjectURL(fileURL);
        
     this.toast.success('File downloading...');   
    }catch(error){
     this.toast.error('Failed to download file');
    }finally{
     this.setLoading(false);
    }
   }

    
  },
};
</script>

<template>
 <layout-header></layout-header>
 <layout-sidebar></layout-sidebar>
  <!-- Page Wrapper -->
 <div class="page-wrapper">
  <div class="content">
  <div class="row align-items-center mb-4">
   <div class="d-md-flex d-sm-block justify-content-between align-items-center flex-wrap">
  <h6 class="fw-medium d-inline-flex align-items-center mb-3 mb-sm-0">
   <router-link :to="{name: 'project'}">
   <i class="ti ti-arrow-left me-2"></i>Back to List</router-link>
  </h6>
  <div class="d-flex">
  <div class="text-end">
   <a href="javascript:void(0);" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#project_modal" @click="$refs.projectModal.project(project);"><i class="ti ti-edit me-1"></i>Edit Project</a>
  </div>
  </div>
  </div>
  </div>

    <div class="row">
    <div class="col-xxl-3 col-xl-4 theiaStickySidebar">
    <div class="card">
    <div class="card-body">
    <h5 class="mb-3">Project Details</h5>
    <div class="list-group details-list-group mb-4">
    <div class="list-group-item">
      <span>Client</span>
      <p class="text-gray-9">{{ project?.customer?.company_name }}</p>
    </div>
    <div class="list-group-item">
      <div class="d-flex align-items-center justify-content-between">
        <span>Project Total Cost</span>
        <p class="text-gray-9">{{ app_currency?.code }} {{ project?.budget }}</p>
      </div>
    </div>
    <div class="list-group-item">
      <div class="d-flex align-items-center justify-content-between">
        <span>Created on</span>
        <p class="text-gray-9">{{ $formatDate(project?.created_at, 'DD MMM YYYY') }}</p>
      </div>
    </div>
    <div class="list-group-item">
      <div class="d-flex align-items-center justify-content-between">
        <span>Started on</span>
        <p class="text-gray-9">{{ $formatDate(project?.start_date, 'DD MMM YYYY') }}</p>
      </div>
    </div>
    <div class="list-group-item">
      <div class="d-flex align-items-center justify-content-between">
       <span>Due Date</span>
       <div class="d-flex align-items-center">
        <p class="text-gray-9 mb-0">{{ $formatDate(project?.end_date, 'DD MMM YYYY') }}</p>
        <span class="badge badge-danger d-inline-flex align-items-center ms-2"><i class="ti ti-clock-stop"></i>1</span>
       </div>
      </div>
    </div>
    <div class="list-group-item">
      <div class="d-flex align-items-center justify-content-between">
        <span>Created by</span>
        <div class="d-flex align-items-center">
          <span class="avatar avatar-sm avatar-rounded me-2">
            <img :src="$profileImage(row?.created_by?.image, clientAdmin)" width="22" alt="Img" />
          </span>
          <p class="text-gray-9 mb-0">{{ project?.created_by?.name }}</p>
        </div>
      </div>
    </div>
    <div class="list-group-item">
      <div class="d-flex align-items-center justify-content-between">
        <span>Priority</span>
        <div class="d-flex align-items-center">
          <p class="text-gray-9 mb-0">{{ project?.priority }}</p>
        </div>
      </div>
    </div>
    
    </div>
    <h5 class="mb-3">Tasks Details</h5>
    <div class="bg-light p-2 rounded">
    <span class="d-block mb-1">Tasks Done</span>
    <h4 class="mb-2">{{ project?.task_stats?.completed }} / {{ project?.task_stats?.total }}</h4>
    <div class="progress progress-xs mb-2">
      <div class="progress-bar" role="progressbar"></div>
    </div>
    <p>{{ projectUtils.calculateProgress(project?.task_stats?.completed, project?.task_stats?.total) }}% Completed</p>
    </div> 
     
    </div>
    </div>
    </div>

    <div class="col-xxl-9 col-xl-8">

    <div class="pipeline-list pipeline-list-two" v-if="pipelines.length">
    <ul>
     <li v-for="(row, index) in pipelines" :key="index">
      <a v-if="projectUtils.visibleTo(auth, project?.project_manager, clientAdmin)" href="javascript:void(0);" :class="row.id === project?.current_pipeline?.pipeline_id ? 'active' : ''" :style="{backgroundColor: row.color_code}" data-bs-toggle="modal" data-bs-target="#project_pipeline_modal" @click="$refs.projectModal.pipelineModal(project?.id, row?.id);">{{ row.name }}</a>
      
      <a v-else href="javascript:void(0);" :class="row.id === project?.current_pipeline?.pipeline_id ? 'active' : ''" :style="{backgroundColor: row.color_code}">{{ row.name }}</a>

     </li> 
    </ul>
    </div>  

    <div class="card">
    <div class="card-body">
    <div class="bg-light rounded p-3 mb-3">
    <div class="d-flex align-items-center">
     <a href="javascript:void(0);" class="flex-shrink-0 me-2">
      <img src="@/assets/img/social/project-01.svg" alt="Img" />
     </a>
      <div>
       <h6 class="mb-1">{{ project?.name }}</h6>
       <p>Project Code : <span class="text-primary"> {{ project?.code }} </span></p>
      </div>
    </div>
    </div>
    <div class="row align-items-center">
    <div class="col-sm-3">
     <p class="d-flex align-items-center mb-3"><i class="ti ti-square-rounded me-2"></i>Status</p>
    </div>
    <div class="col-sm-9">
     <span :class="['badge', 'badge-pill', 'd-inline-flex', 'align-items-center', 'mb-3', {
                    'bg-success': project?.status === 'Completed',
                    'bg-secondary': project?.status === 'In Progress',
                    'bg-primary': project?.status === 'On Hold',
                    'bg-info': project?.status === 'Planning',
                    'bg-danger': project?.status === 'Cancelled'
                   }]"><i class="ti ti-point-filled me-1"></i>{{ project?.status }}</span>
    </div>
   
    <div class="col-sm-3">
     <p class="d-flex align-items-center mb-3"><i class="ti ti-user-star me-2"></i>Project Manager</p>
    </div>
    <div class="col-sm-9">
     <div class="d-flex align-items-center mb-3">
      <div class="bg-gray-100 p-1 rounded d-flex align-items-center me-2">
      <a href="javascript:void(0);" class="avatar avatar-sm avatar-rounded border border-white flex-shrink-0 me-2">
       <img :src="$profileImage(project?.project_manager?.image, clientAdmin)" width="22" alt="Img" />
      </a>
      <h6 class="fs-12"><a href="javascript:void(0);">{{ project?.project_manager?.name }}</a></h6>
      </div>
     <!-- <div>
     <a href="javascript:void(0);" class="d-flex align-items-center fs-12"><i class="ti ti-circle-plus me-1"></i>Add New</a>
     </div> -->
     </div>
    </div>

    <div class="col-sm-3">
     <p class="d-flex align-items-center mb-3"><i class="ti ti-users-group me-2"></i>Team</p>
    </div>

    <div class="col-sm-9">
     <div class="d-flex align-items-center mb-3">

      <div class="bg-gray-100 p-1 rounded d-flex align-items-center me-2" v-for="(row, index) in team_members" :key="index">
      <a href="javascript:void(0);" class="avatar avatar-sm avatar-rounded border border-white flex-shrink-0 me-2">
       <img :src="$profileImage(row?.user?.image, clientAdmin)" width="22" alt="Img" />
      </a>
      <h6 class="fs-12 me-1"><a href="javascript:void(0);">{{ row?.user?.name }}</a></h6>
      <a v-if="projectUtils.visibleTo(auth, project?.project_manager, clientAdmin)" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#remove_team_modal" @click="$refs.projectModal.removeTeamModal(row?.id);"><i class="ti ti-xbox-x text-danger"></i></a>
      </div>
      
      <div v-if="projectUtils.visibleTo(auth, project?.project_manager, clientAdmin)">
       <a href="javascript:void(0);" class="d-flex align-items-center fs-12" data-bs-toggle="modal" data-bs-target="#project_team_modal" @click="$refs.projectModal.team(project?.id);"><i class="ti ti-circle-plus me-1"></i>Add New</a>
      </div>
      </div>
    </div>
    
    <div class="col-sm-12">
      <div class="mb-3">
        <h6 class="mb-1">Description</h6>
        <p v-html="project?.description"></p>
      </div>
    </div>
    <!-- <div class="col-md-12">
     <div class="bg-soft-secondary p-3 rounded d-flex align-items-center justify-content-between">
      <p class="text-secondary mb-0">Time Spent on this project</p>
      <h3 class="text-secondary">65/120 <span class="fs-16">Hrs</span></h3>
     </div>
    </div> -->
    </div>
    </div>
    </div>

    <div class="custom-accordion-items">
    <div class="accordion accordions-items-seperate" id="accordionExample">

    <div class="accordion-item" v-if="projectUtils.visibleTo(auth, project?.project_manager, clientAdmin)">
    <div class="accordion-header" id="headingTwo">
    <div class="accordion-button">
     <h5>Tasks</h5>
     <div class="ms-auto d-flex align-items-center">
     <button v-if="projectUtils.visibleTo(auth, project?.project_manager, clientAdmin)" class="btn bg-primary-transparent btn-sm border-dashed border-primary text-start me-2" data-bs-toggle="modal" data-bs-target="#project_task_modal" @click="$refs.projectModal.task(project?.id);"><i class="ti ti-plus me-2"></i>New task</button>  
     <a href="javascript:void(0);" class="d-flex align-items-center collapsed collapse-arrow" data-bs-toggle="collapse" data-bs-target="#taskAccordian" aria-expanded="false" aria-controls="taskAccordian">
      <i class="ti ti-chevron-down fs-18"></i>
     </a>
     </div>
    </div>
    </div>
    <div id="taskAccordian" class="accordion-collapse collapse show border-top" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
    <div class="accordion-body" style="max-height: 300px; overflow-y: auto;" v-if="project?.tasks?.length">
     <div class="list-group list-group-flush">

      <div class="list-group-item border rounded mb-2 p-2" v-for="(row, index) in project?.tasks" :key="index">
      <div class="row align-items-center row-gap-3">
      <div class="col-md-7">
      <div class="todo-inbox-check d-flex align-items-center flex-wrap row-gap-3" :class="{ 'todo-strike-content': isClickedOne }" @click="toggleClickedOne">
      <div class="strike-info">
      <h4 class="fs-14"><a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#project_task_view_modal" @click="$refs.projectModal.task(project?.id, row);">{{ row.name }}</a></h4>
      </div>
      </div>
      </div>
      <div class="col-md-5">
      <div class="d-flex align-items-center justify-content-md-end flex-wrap row-gap-3">
      <span :class="['badge', 'd-flex', 'align-items-center', 'me-3', {
                    'bg-success': row.status === 'Completed',
                    'bg-info': row.status === 'In Progress',
                    'bg-warning': row.status === 'To Do',
                    'bg-primary': row.status === 'Review',
                    'bg-danger': row.status === 'Cancelled'
                   }]"><i class="fas fa-circle fs-6 me-1"></i>{{ row.status }}</span>
      <div class="d-flex align-items-center">
      <img class="border border-white me-1" :src="$profileImage(row.assigned_to?.image, clientAdmin)" width="22" alt="img"/>
      <label>{{ row.assigned_to?.name }}</label>

      <div class="dropdown ms-2" v-if="row.status !== 'Completed'">
      <a href="javascript:void(0);" class="d-inline-flex align-items-center" data-bs-toggle="dropdown">
      <i class="ti ti-dots-vertical"></i>
      </a>
      <ul class="dropdown-menu dropdown-menu-end p-3">
      <li v-if="projectUtils.visibleTo(auth, project?.project_manager, clientAdmin)">
      <a href="javascript:void(0);" class="dropdown-item rounded-1" data-bs-toggle="modal" data-bs-target="#project_task_modal" @click="$refs.projectModal.task(project?.id, row);"><i class="ti ti-edit me-2"></i>Edit</a>
      </li>
      <li v-if="projectUtils.visibleTo(auth, project?.project_manager, clientAdmin)">
      <a href="javascript:void(0);" class="dropdown-item rounded-1" data-bs-toggle="modal" data-bs-target="#project_task_delete_modal" @click="$refs.projectModal.task(project?.id, row);"><i class="ti ti-trash me-2"></i>Delete</a>
      </li>  
      <li>
      <a href="javascript:void(0);" class="dropdown-item rounded-1" data-bs-toggle="modal" data-bs-target="#project_task_status_modal" @click="$refs.projectModal.task(project?.id, row);"><i class="ti ti-progress me-2"></i>Update Status</a>
      </li>
      <li>
      <a href="javascript:void(0);" class="dropdown-item rounded-1" data-bs-toggle="modal" data-bs-target="#project_task_mark_completed_modal" @click="$refs.projectModal.task(project?.id, row);"><i class="ti ti-progress-check me-2"></i>Mark as completed</a>
      </li>
      </ul>
      </div>

      </div>
      </div>
      </div>
      </div>
      </div>

      </div>
      </div>
    </div>
    </div>

    <div class="accordion-item">
    <div class="accordion-header" id="pipelineHistory">
    <div class="accordion-button">
    <h5>Pipeline History</h5>
    <div class="ms-auto">
      <a href="javascript:void(0);" class="d-flex align-items-center collapsed collapse-arrow" data-bs-toggle="collapse" data-bs-target="#primaryPipelineHistory" aria-expanded="false" aria-controls="primaryPipelineHistory">
        <i class="ti ti-chevron-down fs-18"></i>
      </a>
    </div>
    </div>
    </div>
    <div id="primaryPipelineHistory" class="accordion-collapse collapse show border-top" aria-labelledby="pipelineHistory" data-bs-parent="#primaryPipelineHistory">
    <div class="accordion-body">
     <div class="list-group details-list-group">
      <div class="list-group-item">

        <div class="schedule-timeline" v-if="pipeline_histories.length">

        <div class="d-flex align-items-center" v-for="(row, index) in pipeline_histories">
        <div class="d-flex align-items-center active-time"><span class="timeline-date fw-medium" :style="{color: row?.pipeline?.color_code}">{{ row?.pipeline?.name }}</span>
        <span class="timeline-border d-flex align-items-center justify-content-center bg-white"><i class="ti ti-point-filled text-gray-2 fs-18"></i></span>
        </div>
        <div class="flex-fill ps-3 pb-4 timeline-hrline">
        <div class="mt-4">
          <span class="fw-medium" v-html="row?.notes"></span> <br>
          <small class="text-muted">{{ $formatDate(row?.moved_at) }} ({{ row?.changed_by?.name }})</small>
        </div>
        </div>
        </div>
        
        <div class="d-flex align-items-center">
          <div class="flex-fill ps-3 pb-0 timeline-hrline"></div>
        </div>
        </div>

        <div v-else class="p-3 text-center text-muted">No records found.</div>

      </div>
     </div>
    </div>
    </div>
    </div>

    <div class="accordion-item">
    <div class="accordion-header" id="headingFour">
     <div class="accordion-button">
      <div class="d-flex align-items-center flex-fill">
       <h5>Files</h5>
      <div class="ms-auto d-flex align-items-center">
      <a v-if="projectUtils.visibleTo(auth, project?.project_manager, clientAdmin)" href="javascript:void(0);" class="btn btn-primary btn-xs d-inline-flex align-items-center me-3" data-bs-toggle="modal" data-bs-target="#project_document_modal" @click="$refs.projectModal.document(project?.id);"><i class="ti ti-square-rounded-plus-filled me-1"></i>Add New</a>
      <a href="javascript:void(0);" class="d-flex align-items-center collapsed collapse-arrow" data-bs-toggle="collapse" data-bs-target="#projectDocuments" aria-expanded="false" aria-controls="projectDocuments">
      <i class="ti ti-chevron-down fs-18"></i>
      </a>
      </div>
      </div>
     </div>
    </div>
    <div id="projectDocuments" class="accordion-collapse collapse show border-top" aria-labelledby="headingFour">
    <div class="accordion-body">
     <div class="files-carousel owl-carousel" v-if="project?.documents?.length">
      <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
       <Slide v-for="(row, index) in project?.documents" :key="index">
        <div class="card shadow-none mb-0">
         <div class="card-body">
          <div class="d-flex align-items-center justify-content-between mb-2 pb-2 border-bottom">
           <div class="d-flex align-items-center">
           <div>
            <h6 class="mb-1">{{ row.name }}</h6>
            <span>{{ row.file_size_human }}</span>
           </div>
           </div>
           <div class="d-flex align-items-center">
           <a href="javascript:void(0);" class="btn btn-sm btn-icon" @click="downloadDocument(row);"><i class="ti ti-download"></i></a>
           <a href="javascript:void(0);" class="btn btn-sm btn-icon" data-bs-toggle="modal" data-bs-target="#project_document_view_modal" @click="$refs.projectModal.document(project?.id, row);"><i class="ti ti-eye"></i></a>
           <a v-if="projectUtils.visibleTo(auth, project?.project_manager, clientAdmin)" href="javascript:void(0);" class="btn btn-sm btn-icon" title="Edit" data-bs-toggle="modal" data-bs-target="#project_document_modal" @click="$refs.projectModal.document(project?.id, row)"><i class="ti ti-pencil"></i></a>
           <a v-if="projectUtils.visibleTo(auth, project?.project_manager, clientAdmin)" href="javascript:void(0);" class="btn btn-sm btn-icon" title="Delete" data-bs-toggle="modal" data-bs-target="#project_document_delete_modal" @click="$refs.projectModal.document(project?.id, row)"><i class="ti ti-trash"></i></a>
           </div>
          </div>
          <div class="d-flex align-items-center justify-content-between">
          <p class="fw-medium mb-0">{{ $formatDate(row.created_at, 'DD MMM YYYY, hh:mm A') }}</p>
          <span class="avatar avatar-sm avatar-rounded">
           <img :src="$profileImage(row?.uploaded_by?.image, clientAdmin)" width="22" :alt="row?.uploaded_by?.name" :title="row?.uploaded_by?.name"/></span>
          </div>
          </div>
         </div>
        </Slide>
         <template #addons>
           <!-- <Navigation /> -->
          </template>
         </Carousel>
        </div>
        <div v-else class="p-3 text-center text-muted"> No records found.</div> 
      </div>
    </div>
    </div>
    <div class="row">
    
    <div class="col-xl-12 d-flex">
    <div class="accordion-item flex-fill">
    <div class="accordion-header" id="headingSix">
    <div class="accordion-button">
    <div class="d-flex align-items-center flex-fill">
    <h5>Activity</h5>
    </div>
    </div>
    </div>
    <div id="primaryBorderSix" class="accordion-collapse collapse show border-top" aria-labelledby="headingSix">
    <div class="accordion-body" style="max-height: 300px; overflow-y: auto;" v-if="project?.activities?.length">
    <div class="notice-widget">

    <div class="d-flex align-items-center justify-content-between mb-4" v-for="(row, index) in project?.activities">
    <div class="d-flex overflow-hidden">
    <span class="bg-info avatar avatar-md me-3 rounded-circle flex-shrink-0">
    <i class="ti ti-circle-dot fs-16"></i>
    </span>
    <div class="overflow-hidden">
    <p class="text-truncate mb-1" v-html="row.description"></p>
    <p class="mb-1">{{ $formatDate(row.created_at, 'DD MMM YYYY, hh:mm A') }}</p>
    </div>
    </div>
    </div>
       
    </div>
    </div>
     <div v-else class="p-3 text-center text-muted">No records found.</div>
    </div>
    </div>
    </div>
    </div>
    
    </div>

    <!-- <div class="text-end mb-4">
    <div class="dropdown">
    <a href="javascript:void(0);" class="d-inline-flex align-items-center avatar avatar-lg avatar-rounded bg-primary" data-bs-toggle="dropdown">
     <i class="ti ti-plus fs-24 text-white"></i>
    </a>
    <ul class="dropdown-menu dropdown-menu-end bg-gray-900 dropdown-menu-md dropdown-menu-dark p-3">
    <li>
     <a href="javascript:void(0);" class="dropdown-item rounded-1 d-flex align-items-center">
     <span class="avatar avatar-md bg-gray-800 flex-shrink-0 me-2"><i class="ti ti-basket-code"></i></span>
     <div>
      <h6 class="fw-medium text-white mb-1">Add a Task</h6>
      <p class="text-white">Create a new Priority tasks</p>
     </div>
     </a>
     </li>
     <li>
     <a href="javascript:void(0);" class="dropdown-item rounded-1 d-flex align-items-center">
      <span class="avatar avatar-md bg-gray-800 flex-shrink-0 me-2"><i class="ti ti-file-invoice"></i></span>
       <div>
        <h6 class="fw-medium text-white mb-1">Add Invoice</h6>
        <p class="text-white">Create a new Billing</p>
       </div>
      </a>
      </li>
      <li>
      <a href="javascript:void(0);" class="dropdown-item rounded-1 d-flex align-items-center">
      <span class="avatar avatar-md bg-gray-800 flex-shrink-0 me-2"><i class="ti ti-file-description"></i></span>
      <div>
       <h6 class="fw-medium text-white mb-1">Notes</h6>
       <p class="text-white">Create new note for you & team</p>
      </div>
      </a>
      </li>
      <li>
      <a href="javascript:void(0);" class="dropdown-item rounded-1 d-flex align-items-center">
      <span class="avatar avatar-md bg-gray-800 flex-shrink-0 me-2"><i class="ti ti-folder-open"></i></span>
      <div>
       <h6 class="fw-medium text-white mb-1">Add Files</h6>
       <p class="text-white">Upload New files for this Client</p>
      </div>
      </a>
      </li>
    </ul>
    </div>
    </div> -->
    
    </div>
    </div>
    </div>
    </div>
    <app-footer></app-footer>
    </div>
 <project-modal ref="projectModal" @updated="main()"></project-modal>
</template>
